var map = {
	"./Aeonblight Drake.webp": 2314,
	"./Algorithm of Semi-Intransient Matrix of Overseer Network.webp": 953,
	"./Anemo Hypotasis.webp": 1326,
	"./Azhdaha.webp": 8199,
	"./Bathysmal Vishap.webp": 8918,
	"./Bathysmal Vishaps Herd.webp": 5956,
	"./Childe.webp": 3903,
	"./Cryo Hypotasis.webp": 8698,
	"./Cryo Regisvine.webp": 2125,
	"./Dendro Hypotasis.webp": 3454,
	"./Electro Hypotasis.webp": 404,
	"./Electro Regisvine.webp": 6152,
	"./Emperor of Fire and Iron.webp": 9146,
	"./Experimental Field Generator.webp": 8637,
	"./Geo Hypotasis.webp": 6709,
	"./Golden Wolflord.webp": 6062,
	"./Hydro Hypotasis.webp": 7218,
	"./Hydro Tulpa.webp": 2394,
	"./Icewind Suite.webp": 3595,
	"./Iniquitous Baptist.webp": 1215,
	"./Jadeplume Terrorshroom.webp": 9369,
	"./La Signora.webp": 9738,
	"./Lupus Boreas.webp": 1487,
	"./Magatsu Mitake.webp": 2533,
	"./Maguu Kenki.webp": 8477,
	"./Millennial Pearl Seahorse.webp": 9581,
	"./Oceanid.webp": 7897,
	"./Perpetual Mechanical Array.webp": 6994,
	"./Primo Geovishap.webp": 2805,
	"./Pyro Hypotasis.webp": 4220,
	"./Pyro Regisvine.webp": 8352,
	"./Ruin Serpent.webp": 2679,
	"./Setekh Wenut.webp": 1325,
	"./Shouki no Kami.webp": 6166,
	"./Solitary Suanni.webp": 8241,
	"./Stormterror.webp": 8349,
	"./Thunder Manifestation.webp": 8522,
	"./Warden of Oasis.webp": 9185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3156;